// import { GlobeIcon } from "../../../../componentsicons/globe";
import axios from "axios"
import React, { useEffect, useRef, useState } from "react"
import styles from "./index.module.scss"
import { GlobeIcon } from "../../../components/icons/globe"
import { ArrowdownIcon } from "../../../components/icons/arrow-down"
import { useDispatch, useSelector } from "react-redux"
import { PostionIcon } from "../../../components/icons/position"
import { useGet, getStore, getCookie } from "../../../utils/functions"
import { getMarkers, addZones } from "../../../redux/authSlice"

export default function DropdownLog({ hide, selectedZone, setSelectedZone }) {
  const dispatch = useDispatch()
  const { zones } = useSelector(state => state.user)
  const [zone, setZone] = useState({})
  const [clicks, setClicks] = useState(0)
  const [isDropdown, setIsDropdown] = useState(false)

  const ref = useRef(null)
  const { fetch, fetchedData, isLoading } = useGet(`bins/zone/${zone?.id}/`)

  useEffect(() => {
    if (zone?.id) {
      fetch()
    }
  }, [clicks])

  useEffect(() => {
    dispatch(
      getMarkers(
        fetchedData.map(bin => {
          return {
            lat: bin.Latitude,
            lng: bin.Longitude,
            fill_level: bin["Filled Level"]
          }
        })
      )
    )
  }, [fetchedData])

  // CLOSE DROPDOWN FUNCTION
  useEffect(() => {
    const closeModal = event => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsDropdown(false)
      }
    }
    document.addEventListener("mousedown", closeModal)
  }, [ref])

  useEffect(() => {
    // Call the API endpoint to fetch all zones
    fetchZones()
  }, [])
  
  const fetchZones = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL + 'userzones/'}`, {
        headers: {
          Authorization: `Token ${getStore("auth").token}`,
          'X-CSRFToken': getCookie('csrftoken')
        }
      })
      const zones = response.data
      dispatch(addZones(zones))
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <div ref={ref} className={styles.container}>
      <GlobeIcon
        onClick={() => setIsDropdown(true)}
        className={`${styles.icon} ${hide ? styles.hide : ""}`}
      />
      <input
        readOnly
        onClick={() => setIsDropdown(true)}
        onChange={e => setZone({ ...zones, name: e.target.value })}
        className={hide ? "d-none" : "text-capitalize"}
        value={zone?.name || "All Zones"}
      />
      <ArrowdownIcon
        onClick={() => setIsDropdown(true)}
        className={`${styles.icon} ${hide ? "d-none" : ""}`}
      />

      <section
        className={`${styles.dropdown} shadow ${
          isDropdown ? styles.show : null
        }`}
      >
        <div
          onClick={() => {
            setZone({ name: 'All Zones' })
            setIsDropdown(false)
            setClicks(clicks + 1)
            setSelectedZone('All Zones')
          }}
          className={styles.dropdownItem}
        >
          <PostionIcon className={styles.container_} />
          <div className={"text-capitalize"}>{"All Zones"}</div>
        </div>
        {zones?.map((zone, idx) => {
          return (
            <div
              key={idx}
              onClick={() => {
                setZone(zone)
                setIsDropdown(false)
                setClicks(clicks + 1)
                setSelectedZone(zone.name)
              }}
              className={styles.dropdownItem}
            >
              <PostionIcon className={styles.container_} />
              <div className={"text-capitalize"}>{zone?.name}</div>
            </div>
          )
        })}
      </section>
    </div>
  )
}
